import "../assets/css/Career.css";
import { useEffect, useRef, useState } from "react";
import career_bg from "../assets/images/Career/career-bg.jpg";
import { MdArrowRight } from "react-icons/md";
import { FiChevronRight } from "react-icons/fi";

//ICONS ---------------------------------------------------
import graduate_icon from "../assets/icons/graduation-icon.png";
import hands_on from "../assets/icons/hands-on-uproach.png";
import job_refferal_icon from "../assets/icons/delivery_8830041.png";
import linked_in_icon from "../assets/icons/palcement-icon.png";
import corprate_team_icom from "../assets/icons/immigration_9655089.png";

// Import from icons/ career----------------------------
import resume_icon from "../assets/icons/career/resume-icon.png";
import mock_icon from "../assets/icons/career/mock-interview-icon.png";
import industry_link from "../assets/icons/career/industry-link-icon.png";
import career_icon from "../assets/icons/career/career-icon.png";
import job_portal_icon from "../assets/icons/career/job-portal-icon.png";
import electrical_icon from "../assets/icons/career/electrical&automation-icon.png";
import embedded_icon from "../assets/icons/career/embedded-icon.png";
import it_softwear_icon from "../assets/icons/career/it-icon.png";
import digital_market from "../assets/icons/career/digital-icon.png";
import contact_icon from "../assets/icons/career/contact-icon.png";

import { Helmet } from "react-helmet";
import data from "../../src/component/ApiUrl/meta_api";

// ─── Data ────────────────────────────────────────────────────

const heroStats = [
  { num: "5000+", label: "Students Trained" },
  { num: "95%", label: "Placement Rate" },
  { num: "45 Days", label: "Avg. Time to Placement" },
  { num: "4.8★", label: "Student Rating" },
];

const processSteps = [
  {
    num: "01",
    icon: graduate_icon,
    title: "Industry Training",
    desc: "Hands-on, practical training on real equipment with live project experience from day one.",
  },
  {
    num: "02",
    icon: hands_on,
    title: "Live Project Work",
    desc: "Build a real portfolio project during the course — something tangible to show every employer.",
  },
  {
    num: "03",
    icon: resume_icon,
    title: "Resume & Profile",
    desc: "Professional resume crafted by our career team — tailored to your domain and target roles.",
  },
  {
    num: "04",
    icon: mock_icon,
    title: "Mock Interviews",
    desc: "Practice sessions with industry professionals — technical and HR rounds covered thoroughly.",
  },
  {
    num: "05",
    icon: job_refferal_icon,
    title: "Job Referrals",
    desc: "Direct referrals to our hiring network — companies that actively seek Skimitar graduates.",
  },
];

const placementServices = [
  {
    icon: resume_icon,
    title: "Resume Building",
    desc: "Our career team builds a professional, ATS-friendly resume tailored to your domain, skills, and target companies. No generic templates — a resume that truly represents you.",
  },
  {
    icon: linked_in_icon,
    title: "LinkedIn Optimisation",
    desc: "A strong LinkedIn profile attracts recruiters passively. We help you build a compelling profile that highlights your skills, projects, and certifications — making you visible to hirers.",
  },
  {
    icon: mock_icon,
    title: "Mock Interview Sessions",
    desc: "Structured mock interviews covering technical questions, HR rounds, and situational scenarios — conducted by professionals who know exactly what employers look for.",
  },
  {
    icon: industry_link,
    title: "Industry Referrals",
    desc: "We connect strong graduates directly with companies in our network — a direct referral always carries more weight than a cold application. We use our relationships for your benefit.",
  },
  {
    icon: career_icon,
    title: "Career Counselling",
    desc: "One-on-one sessions to help you identify the right career path, understand salary expectations, and make informed decisions about your professional journey after training.",
  },
  {
    icon: job_portal_icon,
    title: "Job Portal Access",
    desc: "Exclusive access to curated job listings and fresher openings sourced specifically for Skimitar graduates — filtered by domain, location, and experience level.",
  },
];

const hiringDomains = [
  {
    icon: electrical_icon,
    title: "Electrical & Automation",
    roles: [
      { label: "PLC Engineer", bg: "#FCEBEB", color: "#A32D2D" },
      { label: "SCADA Operator", bg: "#FCEBEB", color: "#A32D2D" },
      { label: "Automation Technician", bg: "#FCEBEB", color: "#A32D2D" },
      { label: "Panel Wiring Engineer", bg: "#FCEBEB", color: "#A32D2D" },
      { label: "Maintenance Engineer", bg: "#FCEBEB", color: "#A32D2D" },
    ],
  },
  {
    icon: embedded_icon,
    title: "Embedded Systems & IoT",
    roles: [
      { label: "Embedded Engineer", bg: "#E6F1FB", color: "#0C447C" },
      { label: "Firmware Developer", bg: "#E6F1FB", color: "#0C447C" },
      { label: "IoT Developer", bg: "#E6F1FB", color: "#0C447C" },
      { label: "PCB Designer", bg: "#E6F1FB", color: "#0C447C" },
      { label: "Hardware Engineer", bg: "#E6F1FB", color: "#0C447C" },
    ],
  },
  {
    icon: it_softwear_icon,
    title: "IT & Software",
    roles: [
      { label: "Web Developer", bg: "#EEEDFE", color: "#3C3489" },
      { label: "Python Developer", bg: "#EEEDFE", color: "#3C3489" },
      { label: "Data Analyst", bg: "#EEEDFE", color: "#3C3489" },
      { label: "AI/ML Engineer", bg: "#EEEDFE", color: "#3C3489" },
      { label: "Cloud Engineer", bg: "#EEEDFE", color: "#3C3489" },
    ],
  },
  {
    icon: digital_market,
    title: "Digital Marketing",
    roles: [
      { label: "SEO Specialist", bg: "#E1F5EE", color: "#085041" },
      { label: "Social Media Manager", bg: "#E1F5EE", color: "#085041" },
      { label: "PPC Executive", bg: "#E1F5EE", color: "#085041" },
      { label: "Content Marketer", bg: "#E1F5EE", color: "#085041" },
      { label: "Digital Marketing Executive", bg: "#E1F5EE", color: "#085041" },
    ],
  },
];

const successStories = [
  {
    initials: "KR",
    avatarBg: "#cc0000",
    name: "Karthik R.",
    course: "PLC & Automation · B.E. Graduate",
    quote:
      '"The hands-on training gave me real confidence. I walked into my interview knowing exactly what to say and show. Placed within 45 days of completing the course."',
    result: "Now working as Automation Engineer",
    resultBg: "#E1F5EE",
    resultColor: "#085041",
  },
  {
    initials: "PM",
    avatarBg: "#378ADD",
    name: "Priya M.",
    course: "Digital Marketing · Career Switcher",
    quote:
      '"I was working a completely unrelated job. After the digital marketing course, I started freelancing within 3 months and now manage campaigns for 5 clients full-time."',
    result: "Full-time Freelance Digital Marketer",
    resultBg: "#E1F5EE",
    resultColor: "#085041",
  },
  {
    initials: "AK",
    avatarBg: "#1D9E75",
    name: "Arun K.",
    course: "Embedded Systems & IoT · Fresher",
    quote:
      '"The live project was the game-changer. I had a real IoT system in my portfolio before I even started applying. Every interviewer was impressed by that alone."',
    result: "Joined an Electronics Startup",
    resultBg: "#E1F5EE",
    resultColor: "#085041",
  },
];

const enrollCards = [
  {
    icon: graduate_icon,
    title: "For Students & Freshers",
    desc: "Build job-ready skills with certifications, internships & live projects — with full placement support included.",
  },
  {
    icon: linked_in_icon,
    title: "For Working Professionals",
    desc: "Upskill on weekends, get certified, and unlock better roles and higher salaries in your current field.",
  },
  {
    icon: corprate_team_icom,
    title: "For Corporate HR Teams",
    desc: "Train your team with customized programs — on-site or online — with assessments and certification.",
  },
  {
    icon: job_refferal_icon,
    title: "For Career Switchers",
    desc: "Change your domain completely with structured programs that take you from zero to industry-ready.",
  },
];

const jobs = [
  {
    designation: "PLC Automation Engineer",
    company: "Skimitar Hindusthan Pvt Ltd",
    description:
      "Experience with Siemens / Allen-Bradley PLCs, SCADA configuration, and panel wiring. Minimum 1 year experience preferred.",
    location: "Erode, Tamil Nadu",
    vacancies: "2 Openings",
    deadline: "30 Apr 2025",
  },
  {
    designation: "Embedded Systems Trainee",
    company: "Skimitar Hindusthan Pvt Ltd",
    description:
      "Freshers with knowledge of ARM Cortex, Arduino, Raspberry Pi and basic C/C++ programming. Live project experience is a plus.",
    location: "Erode, Tamil Nadu",
    vacancies: "3 Openings",
    deadline: "15 May 2025",
  },
  {
    designation: "Digital Marketing Executive",
    company: "Skimitar Hindusthan Pvt Ltd",
    description:
      "Proficiency in SEO, Google Ads, Meta Ads, and content strategy. Candidates with our certification will be preferred.",
    location: "Erode / Remote",
    vacancies: "1 Opening",
    deadline: "20 Apr 2025",
  },
];

// ─── Hooks ──────────────────────────────────────────────────

function useScrollReveal(
  sectionRef,
  cardSelector = ".scroll-reveal",
  delay = 80,
) {
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const cards = Array.from(section.querySelectorAll(cardSelector));
    if (!cards.length) return;

    cards.forEach((card, index) => {
      card.style.opacity = "0";
      card.style.transform =
        index % 2 === 0 ? "translateX(-60px)" : "translateX(60px)";
      card.style.transition = "all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            Array.from(entry.target.querySelectorAll(cardSelector)).forEach(
              (card, idx) => {
                setTimeout(() => {
                  card.style.opacity = "1";
                  card.style.transform = "translateX(0)";
                }, idx * delay);
              },
            );
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -50px 0px" },
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, [delay]);
}

function useFadeInUp(ref) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.opacity = "0";
    el.style.transform = "translateY(28px)";
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.style.transition =
            "opacity 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
          el.style.opacity = "1";
          el.style.transform = "translateY(0)";
          observer.disconnect();
        }
      },
      { threshold: 0.12 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
}

function SectionLabel({ text }) {
  return (
    <p
      className="fw-semibold text-uppercase mb-1"
      style={{ fontSize: 20, color: "#cc0000", letterSpacing: 1 }}
    >
      {text}
    </p>
  );
}

// ─── Shared Section Header ───────────────────────────────────

function SectionHeader({ label, title, sub }) {
  return (
    <div className="mb-5">
      <div className="d-flex align-items-center gap-3 mb-2">
        <div className="cr-sec-line" />
        <span
          className="text-uppercase fw-semibold text-cr-red"
          style={{ letterSpacing: "2px", whiteSpace: "nowrap" }}
        >
          {label}
        </span>
        <div className="cr-sec-line" />
      </div>
      <h2 className="cr-section-title fw-bold text-uppercase mt-2">{title}</h2>
      {sub && (
        <p className="mt-2 " style={{ maxWidth: "700px" }}>
          {sub}
        </p>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════
// HERO
// ═══════════════════════════════════════════════════════════
function Hero() {
  return (
    <section className=" cr-hero-section position-relative overflow-hidden">
      <div
        className="cr-hero-bg position-absolute w-100 h-100"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.62), rgba(0,0,0,0.72)), url(${career_bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      <div
        className="container container_width position-relative py-5"
        style={{ zIndex: 1 }}
      >
        {/* Badge */}
        <div className="d-flex justify-content-center mb-3">
          <div className="cr-hero-badge px-2 py-1  rounded-4 d-inline-flex align-items-center gap-3">
            {/* <span className="cr-hero-badge-line ms-2" /> */}
            <span
              className="text-uppercase ms-5 me-5  fw-semibold"
              style={{ letterSpacing: "3px" }}
            >
              Career &amp; Placement
            </span>
            {/* <span className="cr-hero-badge-line me-2" /> */}
          </div>
        </div>

        {/* Title */}
        <h1
          className="cr-hero-title text-white text-center fw-bold mb-3 cr-fade-in"
          style={{ animationDelay: "0.1s" }}
        >
          We Don't Just Train You.
          <br />
          <em className="text-cr-red" style={{ fontStyle: "normal" }}>
            We Launch Your Career.
          </em>
        </h1>

        {/* Sub */}
        <p
          className="text-center mx-auto mb-4 cr-fade-in text-white"
          style={{ maxWidth: "700px", animationDelay: "0.2s" }}
        >
          At Skimitar Hindusthan, placement support is not an afterthought — it
          is built into every program we offer. From day one, we prepare you for
          the industry, not just the exam.
        </p>

        {/* Stats */}
        <div
          className="row g-2 justify-content-center cr-fade-in"
          style={{ animationDelay: "0.3s" }}
        >
          {heroStats.map((s) => (
            <div key={s.num} className="col-6 col-sm-3">
              <div className="cr-stat-box text-center border border-white border-opacity-25 rounded-4 py-3 px-2 h-100">
                <span className="cr-stat-num text-white fw-bold d-block">
                  {s.num}
                </span>
                <span className="text-white">{s.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ═══════════════════════════════════════════════════════════
// HONEST PROMISE
// ═══════════════════════════════════════════════════════════
function HonestPromise() {
  const ref = useRef(null);
  useFadeInUp(ref);

  return (
    <section className="py-5">
      <div className="container container_width" ref={ref}>
        <div className="cr-honest-box p-4 rounded-2 bg-light">
          <p
            className="fw-bold text-uppercase mb-2"
            style={{ letterSpacing: "0.05em" }}
          >
            Our Honest Placement Promise
          </p>
          <p className="mb-0 " style={{ lineHeight: "1.8" }}>
            We will never guarantee 100% placement — no honest training
            institute can. What we do promise is this: every student who
            completes our program with dedication will receive our full career
            support — resume, interviews, referrals, and guidance — until they
            land the right opportunity. Your success is our reputation.
          </p>
        </div>
      </div>
    </section>
  );
}

// ═══════════════════════════════════════════════════════════
// PROCESS STEPS
// ═══════════════════════════════════════════════════════════
function ProcessSection() {
  const sectionRef = useRef(null);
  useScrollReveal(sectionRef, ".scroll-reveal", 90);

  return (
    <section className="py-5 bg-cr-soft cr-section-gap" ref={sectionRef}>
      <div className="container container_width py-lg-4">
        {/* <SectionHeader
          label="Our Process"
          title="How We Take You From Training to Employment"
          sub="A structured, step-by-step journey — from the first day of your course to your first day at work."
        /> */}

        <SectionLabel text="Our Process" />
        <h2 className="fw-semibold mb-5" style={{ fontSize: 20 }}>
          How We Take You From Training to Employment
        </h2>

        <div className="row g-4">
          {processSteps.map((step) => (
            <div
              key={step.num}
              className="col-12 col-sm-6 col-lg scroll-reveal"
            >
              <div className="card h-100 border-0 shadow-sm rounded-0 cr-card-hover">
                <div className="card-body p-4 text-center">
                  <div className="cr-ps-num mx-auto mb-3">{step.num}</div>
                  {/* <div className="cr-ps-icon mb-2">{step.icon}</div> */}
                  <img
                    src={step.icon}
                    className="mb-3"
                    style={{ width: "50px", height: "40px" }}
                  />
                  <p className="fw-bold text-uppercase mb-2">{step.title}</p>
                  <p className="mb-0 " style={{ lineHeight: "1.7" }}>
                    {step.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ═══════════════════════════════════════════════════════════
// PLACEMENT SERVICES
// ═══════════════════════════════════════════════════════════
function PlacementServices() {
  const sectionRef = useRef(null);
  useScrollReveal(sectionRef, ".scroll-reveal", 85);

  return (
    <section className="py-5 cr-section-gap" ref={sectionRef}>
      <div className="container container_width py-lg-4">
        {/* <SectionHeader
          label="Placement Support"
          title="Everything We Do to Get You Placed"
        /> */}

        <SectionLabel text="Placement Support" />
        <h2 className="fw-semibold mb-5" style={{ fontSize: 20 }}>
          Everything We Do to Get You Placed
        </h2>

        <div className="row g-4">
          {placementServices.map((s) => (
            <div key={s.title} className="col-md-6 col-lg-4 scroll-reveal">
              <div className="card h-100 border-0 shadow-sm rounded-0 bg-white cr-card-hover">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center gap-3 mb-3">
                    {/* <div
                      className="cr-pl-icon rounded-2"
                      style={{ background: s.bg, fontSize: "20px" }}
                    >
                      {s.icon}
                    </div> */}
                    <img src={s.icon} className="" style={{ width: "40px" }} />
                    <p className="fw-bold text-uppercase mb-0">{s.title}</p>
                  </div>
                  <p className="mb-0" style={{ lineHeight: "1.75" }}>
                    {s.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ═══════════════════════════════════════════════════════════
// HIRING DOMAINS
// ═══════════════════════════════════════════════════════════
function HiringDomains() {
  const sectionRef = useRef(null);
  useScrollReveal(sectionRef, ".scroll-reveal", 90);

  return (
    <section className="py-5 bg-cr-soft cr-section-gap" ref={sectionRef}>
      <div className="container container_width py-lg-4">
        {/* <SectionHeader
          label="Career Paths"
          title="Roles Our Graduates Are Placed In"
          sub="Here are the most common job roles and career paths that Skimitar graduates pursue after completing their programs."
        /> */}

        <SectionLabel text="Career Paths" />
        <h2 className="fw-semibold mb-5" style={{ fontSize: 20 }}>
          Roles Our Graduates Are Placed In
        </h2>

        <div className="row g-4">
          {hiringDomains.map((d) => (
            <div key={d.title} className="col-md-6 scroll-reveal">
              <div className="card h-100 border-0 shadow-sm rounded-0 bg-white cr-card-hover">
                <div className="card-body p-4 d-flex gap-3">
                  {/* <div className="cr-dom-icon rounded-2 flex-shrink-0" style={{ background: d.bg }}>
                    {d.icon}
                  </div> */}
                  <img
                    src={d.icon}
                    className=""
                    style={{ width: "40px", height: "40px" }}
                  />
                  <div className="flex-grow-1">
                    <p className="fw-bold text-uppercase mb-3">{d.title}</p>
                    <div className="d-flex flex-wrap gap-2">
                      {d.roles.map((r) => (
                        <span
                          key={r.label}
                          className="rounded-pill px-3 py-1 fw-medium"
                          style={{ background: r.bg, color: r.color }}
                        >
                          {r.label}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ═══════════════════════════════════════════════════════════
// SUCCESS STORIES
// ═══════════════════════════════════════════════════════════
function SuccessStories() {
  const sectionRef = useRef(null);
  useScrollReveal(sectionRef, ".scroll-reveal", 100);

  return (
    <section className="py-5 cr-section-gap" ref={sectionRef}>
      <div className="container container_width py-lg-4">
        {/* <SectionHeader
          label="Success Stories"
          title="Real Students. Real Careers. Real Impact."
        /> */}

        <SectionLabel text="Success Stories" />
        <h2 className="fw-semibold mb-5" style={{ fontSize: 20 }}>
          Real Students. Real Careers. Real Impact.
        </h2>

        <div className="row g-4">
          {successStories.map((s) => (
            <div key={s.name} className="col-md-4 scroll-reveal">
              <div className="card h-100 border-0 shadow-sm rounded-0 overflow-hidden cr-card-hover">
                <div className="cr-story-top p-4">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle mb-3 fw-bold flex-shrink-0"
                    style={{
                      background: s.avatarBg,
                      color: "#fff",
                      width: "48px",
                      height: "48px",
                    }}
                  >
                    {s.initials}
                  </div>
                  <p className="fw-bold text-white mb-1">{s.name}</p>
                  <p className="mb-0" style={{ color: "#aaa" }}>
                    {s.course}
                  </p>
                </div>
                <div className="card-body p-4 bg-white">
                  <p
                    className="fst-italic mb-3 "
                    style={{ lineHeight: "1.75" }}
                  >
                    {s.quote}
                  </p>
                  <div
                    className="d-flex align-items-center gap-2 rounded-2 px-3 py-2"
                    style={{ background: s.resultBg }}
                  >
                    <span className="cr-story-dot" />
                    <span
                      className="fw-semibold"
                      style={{ color: s.resultColor }}
                    >
                      {s.result}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ═══════════════════════════════════════════════════════════
// JOB OPENINGS
// ═══════════════════════════════════════════════════════════
function JobOpenings() {
  const ref = useRef(null);
  useFadeInUp(ref);

  return (
    <section className="py-5 bg-cr-soft cr-section-gap">
      <div className="container container_width py-lg-4" ref={ref}>
        {/* <SectionHeader
          label="Open Positions"
          title="Current Job Openings"
          sub="Explore open roles at Skimitar Hindusthan and our partner companies. Apply directly or reach out to our placement team."
        /> */}

        <SectionLabel text="Open Positions" />
        <h2 className="fw-semibold mb-5" style={{ fontSize: 20 }}>
          Current Job Openings
        </h2>

        <div className="d-flex flex-column gap-4">
          {jobs.map((job, idx) => (
            <div
              key={idx}
              className="card border-0 shadow-sm rounded-0 cr-job-card-hover"
            >
              <div className="cr-job-bg px-4 py-3 d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                <div>
                  <p
                    className="fw-bold text-uppercase mb-1"
                    style={{ fontSize: "18px" }}
                  >
                    {job.designation}
                  </p>
                  <div className="d-flex align-items-center gap-2">
                    <FiChevronRight />
                    <span>{job.company}</span>
                  </div>
                </div>
                <button className="btn btn-danger fw-bold text-uppercase align-self-start align-self-md-center">
                  Apply Now
                </button>
              </div>
              <div className="card-body px-4 py-3 bg-white">
                <p className="mb-3" style={{ lineHeight: "1.75" }}>
                  <MdArrowRight />
                  {job.description}
                </p>
                <div className="row g-2">
                  <div className="col-12 col-sm-4">
                    <MdArrowRight />
                    <strong>{job.location}</strong>
                  </div>
                  <div className="col-12 col-sm-4">
                    <MdArrowRight />
                    <strong>{job.vacancies}</strong>
                  </div>
                  <div className="col-12 col-sm-4">
                    <MdArrowRight />
                    Deadline: <strong>{job.deadline}</strong>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ═══════════════════════════════════════════════════════════
// ENROLL / COUNSELLING FORM
// ═══════════════════════════════════════════════════════════
function EnrollSection() {
  const [isChecked, setIsChecked] = useState(false);
  const ref = useRef(null);
  useFadeInUp(ref);

  return (
    <section className="py-5 cr-section-gap">
      <div className="container container_width py-lg-4" ref={ref}>
        {/* <SectionHeader
          label="Get Started"
          title="Ready to Start Your Career Journey?"
          sub="Tell us your background and what you're looking for — our counsellors will guide you to the right program and placement path."
        /> */}

        <SectionLabel text="Get Started" />
        <h2 className="fw-semibold mb-5" style={{ fontSize: 20 }}>
          Ready to Start Your Career Journey?
        </h2>

        <div className="row g-4 align-items-start">
          {/* Cards */}
          <div className="col-lg-12">
            <div className="row g-3">
              {enrollCards.map((c) => (
                <div key={c.title} className="col-12 col-sm-6 scroll-reveal">
                  <div className="card h-100 border-0 shadow-sm rounded-0 cr-card-hover">
                    <div className="card-body p-3 d-flex gap-3">
                      {/* <span style={{ fontSize: "26px", flexShrink: 0 }}>{c.icon}</span> */}
                      <img
                        src={c.icon}
                        style={{ width: "40px", height: "40px" }}
                      />
                      <div>
                        <p className="fw-bold mb-1">{c.title}</p>
                        <p className="mb-0 " style={{ lineHeight: "1.7" }}>
                          {c.desc}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Form */}
          <div className="col-lg-12 mt-5">
            <div className="card border-0 shadow rounded-0 scroll-reveal">
              <div className="card-body p-4 p-lg-5">
                <div className="d-flex align-items-center justify-content-center gap-2 mb-4">
                  <span>
                    <img
                      src={contact_icon}
                      style={{ width: "40px", height: "40px" }}
                      alt=""
                    />
                  </span>

                  <p
                    className="fw-bold border-bottom pb-3 mb-0"
                    style={{ fontSize: "18px" }}
                  >
                    Talk to Our Career Counsellor
                  </p>
                </div>

                <div className="row">
                  <div className="col-6">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Your Name *
                      </label>
                      <input
                        type="text"
                        className="form-control cr-input"
                        placeholder="Full name"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Phone Number *
                      </label>
                      <input
                        type="tel"
                        className="form-control cr-input"
                        placeholder="+91 XXXXX XXXXX"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control cr-input"
                        placeholder="you@email.com"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Current Status
                      </label>
                      <select className="form-select cr-input">
                        <option>Select your status</option>
                        <option>Student / Fresher</option>
                        <option>Working Professional</option>
                        <option>Career Switcher</option>
                        <option>Business Owner</option>
                        <option>HR / Corporate</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Domain of Interest
                      </label>
                      <select className="form-select cr-input">
                        <option>Select a domain</option>
                        <option>Electrical &amp; Automation</option>
                        <option>Embedded Systems &amp; IoT</option>
                        <option>IT &amp; Software Development</option>
                        <option>AI &amp; Data Science</option>
                        <option>Digital Marketing</option>
                        <option>Not Sure — Need Guidance</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mb-4">
                      <label className="form-label fw-semibold">
                        Upload Resume (Optional)
                      </label>
                      <input type="file" className="form-control cr-input" />
                    </div>
                  </div>
                </div>
                <div className="d-flex gap-3 mb-4">
                  <input
                    type="checkbox"
                    id="cr-terms"
                    className="form-check-input mt-1 flex-shrink-0"
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                      accentColor: "#cc0000",
                    }}
                  />
                  <label
                    htmlFor="cr-terms"
                    className=""
                    style={{ lineHeight: "1.65", cursor: "pointer" }}
                  >
                    By joining our community, we will store your personal
                    information and consider you for job opportunities and
                    programs aligned with your interests.
                  </label>
                </div>

                <button
                  type="button"
                  className=" w-100 cr-submit-btn fw-bold text-uppercase py-3"
                  disabled={!isChecked}
                >
                  Book Free Counselling Session →
                </button>
                <p className="text-center mt-3 mb-0">
                  Free · No commitment · Response within 24 hours
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ═══════════════════════════════════════════════════════════
// CTA
// ═══════════════════════════════════════════════════════════
function CTA() {
  return (
    <section className=" cr-section-gap">
      <div className="cr-cta-wrap p-4 p-lg-5">
        <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
          <div className="cr-eyebrow-line" />
          <span
            className="text-uppercase fw-semibold text-white text-opacity-75"
            style={{ letterSpacing: "2px", whiteSpace: "nowrap" }}
          >
            Your Career Starts Here
          </span>
          <div className="cr-eyebrow-line" />
        </div>
        <div className="row g-4 align-items-center">
          <div className="col-lg-7 text-center text-lg-start">
            <h2 className="fw-bolder text-white text-uppercase mb-3 cr-section-title">
              Your Next Career Move Begins at Skimitar
            </h2>
            <p
              className="text-white text-opacity-75 mb-0"
              style={{ lineHeight: "1.75" }}
            >
              Join hundreds of students who chose the right training, built real
              skills, and landed the careers they wanted — with Skimitar's
              honest, practical support every step of the way.
            </p>
          </div>
          <div className="col-lg-5">
            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-end">
              <button className="btn cr-btn-white px-4 py-3 fw-bold text-uppercase">
                Explore Courses →
              </button>
              <button className="btn cr-btn-ghost px-4 py-3 fw-bold text-uppercase">
                📞 (+91) 8428010909
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── MAIN EXPORT ─────────────────────────────────────────────
export default function Career() {
  const [meta, setMeta] = useState(null);

  const fetchData = () => {
    const CareerMeta = data[0]?.career_page;
    if (CareerMeta) {
      setMeta(CareerMeta);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="career-page overflow-x-hidden">
      <Helmet>
        <title>{meta ? meta.title : "Career"}</title>
      </Helmet>

      <Hero />
      <HonestPromise />
      <ProcessSection />
      <PlacementServices />
      <HiringDomains />
      <SuccessStories />
      <JobOpenings />
      <EnrollSection />
      <CTA />
    </div>
  );
}
